import styled from '@emotion/styled';
import React, { useEffect, useRef } from 'react';

import { scrollbarDark } from '../../../../theme/elements/scrollbars';
import { su } from '../../../../theme/functions/su';

import { TextSmall } from '../../../../components/common/text/TextSmall';

export function ArgumentHomeyScriptOutput(props) {
  const scrollRef = useRef();

  useEffect(() => {
    const scrollElement = scrollRef.current;

    if (scrollElement != null) {
      scrollElement.scrollTop = scrollElement.scrollHeight - scrollElement.clientHeight;
    }
  }, [props.logs]);

  return (
    <ArgumentHomeyScriptOutput.Root ref={scrollRef}>
      {props.logs.map((log, index) => {
        return <pre key={index}>{log}</pre>;
      })}
    </ArgumentHomeyScriptOutput.Root>
  );
}

ArgumentHomeyScriptOutput.Root = styled(TextSmall)`
  ${scrollbarDark};
  flex: 1 1 0;
  padding: ${su(1)};
  overflow-y: auto;

  &,
  pre {
    font-family:
      Roboto Mono,
      monospace;
    font-feature-settings:
      'liga' 0,
      'calt' 0;
  }
`;
